import { useMutation } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import {
  ActionOutboxEntityType,
  PricingClient,
  VelocityCircuitBreakerSuppressionType,
} from 'src/WebApiController';

export const useSuppressCircuitBreakerActions = () => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();
  const { refreshEventForItems } = useCatalogDataContext();

  const suppressVelocityCircuitBreakerMutation = useMutation({
    mutationFn: async ({
      listingId,
      suppressionType,
    }: {
      listingId: number;
      suppressionType: VelocityCircuitBreakerSuppressionType;
    }) => {
      const client = new PricingClient(activeAccountWebClientConfig);
      return await client.suppressVelocityCircuitBreaker(
        listingId,
        suppressionType
      );
    },
    onSuccess: async (data, { listingId }) => {
      refreshEventForItems([listingId], ActionOutboxEntityType.Listing);
    },
    onError: (err: ErrorTypes, { listingId }, context) => {
      showErrorDialog('PricingClient.suppressVelocityCircuitBreaker', err, {
        trackErrorData: { listingId },
      });
    },
  });

  return {
    onSubmit: suppressVelocityCircuitBreakerMutation.mutate,
  };
};
